import CmsContentPage from "./CmsContentPage";
import ContactForm from "../components/ContactForm";
import { useSettings } from "../lib/cms";
import { Phone, Mail, MapPin, Clock, MessageCircle } from "lucide-react";

const FALLBACK =
  "https://images.unsplash.com/photo-1740695600568-a7e54e7d3614?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHxyYW5nZSUyMHJvdmVyJTIwc3V2JTIwZGFya3xlbnwwfHx8fDE3NzgwNTM2MDh8MA&ixlib=rb-4.1.0&q=85";

const ContactPage = () => {
  const { settings } = useSettings();
  const s = settings || {};
  const phone = s.phone || "+31 20 123 45 67";
  const email = s.email || "contact@maisonvellore.nl";
  const address = s.address || "Herengracht 412, 1017 BZ Amsterdam";
  const hours = s.opening_hours || "Op afspraak — di t/m za, 10:00 – 18:00";
  const wa = s.whatsapp_url;

  const contactSlot = (
    <section
      data-testid="contact-slot"
      className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-12 py-16 md:py-24"
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
        <aside className="lg:col-span-5">
          <p className="text-[11px] tracking-[0.3em] uppercase text-champagne font-body mb-3">
            Contactgegevens
          </p>
          <h2 className="font-display text-3xl md:text-4xl text-white tracking-tight mb-8">
            Wij staan u graag persoonlijk te woord.
          </h2>

          <ul className="flex flex-col gap-5">
            <ContactRow
              icon={<MapPin size={14} />}
              label="Atelier"
              value={<span style={{ whiteSpace: "pre-line" }}>{address}</span>}
            />
            <ContactRow
              icon={<Phone size={14} />}
              label="Telefoon"
              value={
                <a
                  href={`tel:${phone.replace(/\s/g, "")}`}
                  className="hover:text-champagne transition-colors"
                  data-testid="contact-page-phone"
                >
                  {phone}
                </a>
              }
            />
            <ContactRow
              icon={<Mail size={14} />}
              label="E-mail"
              value={
                <a
                  href={`mailto:${email}`}
                  className="hover:text-champagne transition-colors"
                  data-testid="contact-page-email"
                >
                  {email}
                </a>
              }
            />
            <ContactRow icon={<Clock size={14} />} label="Bezichtiging" value={hours} />
            {wa && (
              <ContactRow
                icon={<MessageCircle size={14} />}
                label="WhatsApp"
                value={
                  <a
                    href={wa}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-champagne transition-colors"
                  >
                    Stuur direct een bericht
                  </a>
                }
              />
            )}
          </ul>
        </aside>

        <div className="lg:col-span-7">
          <ContactForm />
        </div>
      </div>
    </section>
  );

  return (
    <CmsContentPage
      pageKey="contact"
      fallbackHero={FALLBACK}
      dataTestId="contact-page"
      contactSlot={contactSlot}
    />
  );
};

const ContactRow = ({ icon, label, value }) => (
  <li className="flex items-start gap-4">
    <span className="mt-1 text-champagne-muted">{icon}</span>
    <div className="flex flex-col">
      <span className="text-[10px] tracking-[0.3em] uppercase text-zinc-500 font-body">
        {label}
      </span>
      <span className="text-base text-zinc-200 font-body mt-1">{value}</span>
    </div>
  </li>
);

export default ContactPage;
